import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "../site/motion";

export const NextCase = ({ c }) => (
  <section data-testid="case-next" className="border-t border-cream/10">
    <Link to={`/work/${c.slug}`} data-testid="case-next-link" className="group relative block overflow-hidden" style={{ "--case": c.accent }}>
      <div className="absolute inset-0 origin-bottom scale-y-0 bg-skaris-navy transition-transform duration-700 ease-[cubic-bezier(.16,1,.3,1)] group-hover:scale-y-100" />
      <div className="relative mx-auto flex max-w-[1440px] flex-col gap-6 px-6 py-20 md:flex-row md:items-end md:justify-between md:px-10 md:py-28">
        <FadeUp>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-cream/60">Next case study · {c.kicker}</p>
          <p className="mt-4 font-display text-6xl font-semibold uppercase leading-[0.85] tracking-[-0.04em] text-cream transition-transform duration-700 group-hover:translate-x-4 md:text-[9rem]">{c.name}</p>
        </FadeUp>
        <span className="flex h-20 w-20 items-center justify-center rounded-full border border-cream/30 text-cream transition-[background-color,color,transform] duration-500 group-hover:rotate-45 group-hover:bg-cream group-hover:text-skaris-ink">
          <ArrowUpRight className="h-7 w-7" />
        </span>
      </div>
    </Link>
  </section>
);
